import { render, staticRenderFns } from "./fourPage.vue?vue&type=template&id=6b716870&"
import script from "./fourPage.vue?vue&type=script&lang=js&"
export * from "./fourPage.vue?vue&type=script&lang=js&"
import style0 from "./fourPage.vue?vue&type=style&index=0&id=6b716870&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports